import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const InvoiceEliminarProcesoModal = ({ show, row, onClose, onConfirm, loading }) => {
  const booking = row?.nro_booking ? String(row.nro_booking).trim() : '';
  const bl = row?.nombre_bl ? String(row.nombre_bl).trim() : '';

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Eliminar proceso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">¿Está seguro de que desea eliminar este proceso?</p>
        {(booking || bl) && (
          <p className="text-muted small mb-0">
            {booking ? (
              <>
                Booking: <strong>{booking}</strong>
              </>
            ) : null}
            {booking && bl ? ' · ' : null}
            {bl ? (
              <>
                BL: <strong>{bl}</strong>
              </>
            ) : null}
          </p>
        )}
        <p className="text-muted small mt-2 mb-0">
          Se eliminarán el packing list y la invoice asociada (si existe).
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading || !row?.id_packing_list}>
          {loading ? 'Eliminando…' : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoiceEliminarProcesoModal;
